/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Slot_Generation_Remove_AllInputs */

const en_job_form_slot_generation_remove_all = /** @type {(inputs: Job_Form_Slot_Generation_Remove_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove all unbooked appointments`)
};

const de_job_form_slot_generation_remove_all = /** @type {(inputs: Job_Form_Slot_Generation_Remove_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle ungebuchten Termine entfernen`)
};

/**
* | output |
* | --- |
* | "Remove all unbooked appointments" |
*
* @param {Job_Form_Slot_Generation_Remove_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_slot_generation_remove_all = /** @type {((inputs?: Job_Form_Slot_Generation_Remove_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Slot_Generation_Remove_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_slot_generation_remove_all(inputs)
	return en_job_form_slot_generation_remove_all(inputs)
});